interface Attribute {
  entity_id: string;
  entity_type: string;
  key: string;
  source?: string;
  value: string;
  version: string;
  deleted_at?: string;
  updated_at?: string;
  created_at?: string;
}

const ATTRIBUTE_TOPIC = "attributes";

export { Attribute, ATTRIBUTE_TOPIC };
